<script setup>
import { getRegion } from '../helpers.js';

const region = getRegion();
const berlinNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
const cutoff = new Date(new Date().getFullYear(), 11, 24, 23, 59, 59);
const show = region === 'de' && berlinNow <= cutoff;
</script>

<template>
    <div v-if="show">
        <video
            :src="$asset('/hkcm/images/adventskalender/AdventskalenderBanner.webm', 'public')"
            aria-label="HKCM-Adventskalender-Banner"
            class="hidden md:block w-full h-full"
            autoplay
            loop
            muted
            playsinline
            preload="auto"
        />
        <video
            :src="$asset('/hkcm/images/adventskalender/AdventskalenderBannerMobile.webm', 'public')"
            aria-label="HKCM-Adventskalender-Banner"
            class="block md:hidden w-full h-full"
            autoplay
            loop
            muted
            playsinline
            preload="auto"
        />
    </div>
</template>
